import React from 'react';
import { FadeIn } from './FadeIn';
export function ProofSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-brand-amber/5 border-y border-brand-amber/10" data-id="element-155">
      <div className="max-w-3xl mx-auto text-center" data-id="element-156">
        <FadeIn data-id="element-157">
          <p className="text-xl sm:text-2xl text-brand-offwhite font-serif leading-relaxed italic" data-id="element-158">
            "En solo 7 días, pasarás de la hipervigilancia constante (revisar el
            celular cada 5 minutos) a una sensación de control sobre tu propio
            futuro. No te prometemos que el dolor desaparecerá mágicamente, pero
            te garantizamos que la confusión se irá. Sabrás exactamente dónde
            estás parado."
          </p>
        </FadeIn>
      </div>
    </section>;
}